// Helper to render the device fingerprinting iframe.
//
// Browser-only: the function body requires `document` — never call during
// SSR. Importing this module is SSR-safe; only invocation touches the DOM.
export const renderFingerprintingIframe = (html: string): Promise<void> => {
  return new Promise((resolve) => {
    const iframe = document.createElement("iframe");
    iframe.srcdoc = html;
    iframe.style.display = "none";

    document.body.appendChild(iframe);

    // Wait for fingerprinting to complete (usually <10 seconds)
    setTimeout(() => {
      document.body.removeChild(iframe);
      resolve();
    }, 10000);
  });
};
